export default __webpack_public_path__ + "static/media/joaquin-ramiro.50d9e0fe.png";